import type { WSearchTranslations } from "./pl";

const GROUP_LABELS: Record<string, string> = {
  catalogs: "Catalogs",
  products: "Products",
  articles: "Articles",
};

export const en: WSearchTranslations = {
  open: "Open search",
  title: "Search",
  close: "Close",
  searchLabel: "Search",
  inputLabel: "Search",
  placeholder: "Search products, categories, pages...",
  suggestionsLabel: "Suggestions",
  loading: "Searching...",
  popularLabel: "Popular searches",
  notConfigured: "Search is not configured (no results page).",
  groupLabel: (key) => GROUP_LABELS[key] ?? key,
};
